import { render, staticRenderFns } from "./Complaints.vue?vue&type=template&id=59e54323&scoped=true"
import script from "./Complaints.vue?vue&type=script&lang=js"
export * from "./Complaints.vue?vue&type=script&lang=js"
import style0 from "./Complaints.vue?vue&type=style&index=0&id=59e54323&prod&scoped=true&lang=css"
import style1 from "./Complaints.vue?vue&type=style&index=1&id=59e54323&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e54323",
  null
  
)

export default component.exports